export const ROUTER_LOGIN_URL = '/';
export const LOCATION_LIST_URL = '/locations';
const LOCATION_DETAIL_URL = `${LOCATION_LIST_URL}/:locationRef`;
export const BOOKING_LIST_URL = `${LOCATION_DETAIL_URL}/bookings`;
export const BOOKING_TRACKER_URL = `${LOCATION_DETAIL_URL}/booking-tracker`;
export const BOOKING_DETAIL_URL = `${BOOKING_LIST_URL}/:bookingId`;
export const ALLOCATIONS_URL = `${LOCATION_DETAIL_URL}/allocations`;
export const DEV_PLAYGROUND_URL = '/playground';
export const FRONT_DESK_URL = `${LOCATION_DETAIL_URL}/front-desk`;
export const STATUS_PAGE_URL = `${LOCATION_DETAIL_URL}/integrations/status`;
export const ACCEPT_INVITATION = '/invite-confirmation/:key';
export const USER_LIST_URL = '/users/';
export const FORGOT_PASSWORD = '/forgot-password/';
export const FORGOT_PASSWORD_SET = '/forgot-password-set/:token';
export const MY_TEAMS = '/my-teams';
export const WEBHOOKS_URL = '/webhooks';
export const QUICK_SEARCH_URL = '/search';
export const BOOKING_SET_LIST_URL = `${LOCATION_DETAIL_URL}/booking-sets`;
export const AVAILABILITY_URL = `${LOCATION_DETAIL_URL}/availability`;
export const BOOKING_SET_DETAIL_URL = `${LOCATION_DETAIL_URL}/booking-set/:bookingSetId`;
export const MEMBER_LIST_URL = `${LOCATION_DETAIL_URL}/members`;
export const MEMBER_DETAILS_URL = `${MEMBER_LIST_URL}/:memberId`;
export const NOTES_LIST_URL = `${LOCATION_DETAIL_URL}/notes`;
export const PAYMENTS_LIST_URL = `${LOCATION_DETAIL_URL}/payments`;
export const CREDIT_NOTES_LIST_URL = `${LOCATION_DETAIL_URL}/credit-notes`;
export const ONE_OFF_CHARGE_REASONS_URL = `${LOCATION_DETAIL_URL}/one-off-charge-reasons`;
const REPORTING_NAMESPACE = `${LOCATION_DETAIL_URL}/reporting`;
export const OCCUPANCY_REPORTING_URL = `${REPORTING_NAMESPACE}/occupancy`;
export const INVOICE_REPORTING_URL = `${REPORTING_NAMESPACE}/invoices`;
export const REVENUE_REPORTING_URL = `${REPORTING_NAMESPACE}/revenue`;
export const LOOKER_REPORTING_URL = `${REPORTING_NAMESPACE}/looker`;
export const ROOM_PURPOSES_URL = `${LOCATION_DETAIL_URL}/room-purposes`;

export const PAGE_NOT_FOUND_KEY = '/page-not-found';
